/*
 * Built with Common Launchpad 2.0.3
 */

import { getField, updateField } from 'vuex-map-fields';
import listing from '../api/listing';

/* ---------------------------------------------
   Helper functions
--------------------------------------------- */

function applySpecificationUpdate(state, key, value) {
    if (Object.prototype.hasOwnProperty.call(state.specification, key)) {
        state.specification[key] = value != null ? value : '';

        if (value === '999') {
            state.specification[key] = '';
        }

        // Paging logic
        if (key !== 'PageIndex') {
            state.specification.PageIndex = 0;
            state.pagination.pageIndex = 1;
            if (state.specification.Skip !== undefined) {
                state.specification.Skip = 0;
            }
        } else {
            state.pagination.pageIndex = value + 1;

            if (value === 0 && state.specification.Skip !== undefined) {
                state.specification.Skip = 0;
            }
        }

        // Sort resets Skip
        if (key === 'Sort' && state.specification.Skip !== undefined) {
            state.specification.Skip = 0;
        }
    }
}

function buildUrl(state) {
    const encodeDataToURL = (data) => Object.keys(data).map((key) => `${key}=${encodeURIComponent(data[key])}`).join('&');

    const removeEmpty = (obj) => {
		const newObj = {};
		Object.keys(obj).forEach((key) => {
			const val = obj[key];
			if (val !== null && val !== '' && val !== '999') {
				newObj[key] = val;
			}
		});
		return newObj;
	};	

    const cleaned = removeEmpty(state.specification);

    return (`${window.location.protocol}//${window.location.host}${state.listingUrl || window.location.pathname}?${encodeDataToURL(cleaned)}`);
}

function pushUrlOnce(url) {
    if (window.history.pushState) {
        window.history.pushState({ path: url }, '', url);
    }
}

/* ---------------------------------------------
   Vuex Module
--------------------------------------------- */

const state = {
    error: '',
    loading: false,
    listing: [],
    resource: 'locationfinder',
    specification: {},
    listingUrl: '',
    pagination: {
        pageIndex: 0,
        pageSize: 0,
        rowEnd: 0,
        rowStart: 0,
        total: 0,
        totalPages: 0,
    },
    initState: {},
    selectedLocation: '',
    initMsg: true,
};

const getters = {
    getField,
};

const actions = {
    updateError({ commit }, error) {
        commit('updateError', error);
    },
    updateLoading({ commit }, loading) {
        commit('updateLoading', loading);
    },
    setFilter({ commit }) {
        listing.setFilter((data) => {
            commit('setListing', data);
        }, { specification: state.specification, resource: state.resource });
    },
};

const mutations = {
    updateField,

    updateError(state, error) {
        state.error = error;
    },

    updateLoading(state, loading) {
        state.loading = loading;
    },

    setInitData(state, result) {
        state.initState = result;
        state.specification = { ...result.Specification };

        state.pagination.pageIndex = result.PageIndex + 1;
        state.pagination.pageSize = result.PageSize;
        state.pagination.rowEnd = result.RowEnd;
        state.pagination.rowStart = result.RowStart;
        state.pagination.total = result.Total;
        state.pagination.totalPages = result.TotalPages;
    },

    isCollectionPage(state, data) {
        state.isCollectionPage = data;
    },

    setListingRedirect(state, listingUrl) {
        state.listingUrl = listingUrl;
    },

    setResource(state, resource) {
        state.resource = resource;
    },

    /* ---------------------------------------------
       SINGLE update
    --------------------------------------------- */
    updateSpecification(state, param) {
        applySpecificationUpdate(state, param.key, param.value);

        const url = buildUrl(state);
        pushUrlOnce(url);
    },

    /* ---------------------------------------------
       BATCH update (runs URL push ONCE)
    --------------------------------------------- */
    updateSpecifications(state, params) {
        params.forEach((p) => {
            applySpecificationUpdate(state, p.key, p.value);
        });

        const url = buildUrl(state);
        pushUrlOnce(url);
    },

    updateSpecificationByHistory(state) {
        let params = new URLSearchParams(window.location.search.substring(1));
        state.specification.PageIndex = params.get('PageIndex');
        state.specification.Query = params.get('Query') === null ? params.get('query') : params.get('Query');
    },

    resetSpecification(state) {
        state.specification = { ...state.initState.Specification };

        state.pagination.pageIndex = state.initState.PageIndex + 1;
        state.pagination.pageSize = state.initState.PageSize;
        state.pagination.rowEnd = state.initState.RowEnd;
        state.pagination.rowStart = state.initState.RowStart;
        state.pagination.total = state.initState.Total;
        state.pagination.totalPages = state.initState.TotalPages;

        const url = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        pushUrlOnce(url);
    },

    setListing(state, data) {
        state.initMsg = false;
        state.listing = data.Items;
        state.specification = data.Specification;

        state.pagination.pageIndex = data.PageIndex + 1;
        state.pagination.pageSize = data.PageSize;
        state.pagination.rowEnd = data.RowEnd;
        state.pagination.rowStart = data.RowStart;
        state.pagination.total = data.Total;
        state.pagination.totalPages = data.TotalPages;
    },

    setSelectedLocation(state, data) {
        state.selectedLocation = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
